import { render } from "./shopAddMoney.vue?vue&type=template&id=4d7dcef0&scoped=true"
import script from "./shopAddMoney.vue?vue&type=script&lang=js"
export * from "./shopAddMoney.vue?vue&type=script&lang=js"

import "./shopAddMoney.vue?vue&type=style&index=0&id=4d7dcef0&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7dcef0"]])

export default __exports__